/* istanbul ignore file */

import { routerSlice } from "../../slices/router";
export { handleGeneralError };

/* istanbul ignore next */
function handleGeneralError(dispatch) {
  dispatch(routerSlice.actions.changeRoute('general_error'));
}